import React from 'react';
import { useCallback } from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ArrayChecker, Table } from '../../../components';
import apiService from '../../../features/api/service';
import { fetchEvent } from '../../../features/event/slice';
import { useInternationalization } from '../../../features/i18n';
import { errorHandler } from '../../../utils';

const SectionComment = () => {
  const dispatch = useDispatch()
  const { comments = [], id: eventId } = useSelector(state => state.event.data)
  const { translate } = useInternationalization()

  const handleDelete = useCallback((id) => {
    if(id){
      apiService.delete('comment', id)
        .then(() => {
          toast.success('Deleted.')
          dispatch(fetchEvent(eventId))
        })
        .catch(err => {
          const msg = errorHandler(err)
          toast.error(msg)
        })
    }
  }, [dispatch, eventId])

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'user.name',
      },
      {
        Header: 'Date',
        accessor: 'date',
      },
      {
        Header: 'Comment',
        accessor: 'text',
      },
      {
        Header: 'Action',
        accessor: 'id',
        Cell: (props) => {
          return (
            <p
              className="cursor-pointer text-sm text-gray-444 underline"
              onClick={() => handleDelete(props.value)}
            >
              Delete
            </p>
          )
        }
      }
    ],
    [/* language */handleDelete]
  )

  return <>
    <p className="text-lg font-bold mb-5 lg:mb-8">{translate('GENERAL', 'comment_plural')}</p>
    <ArrayChecker data={comments}>
      <Table
        data={comments}
        columns={tableColumns}
      />
    </ArrayChecker>
  </>
}

export default SectionComment
